import { render } from "./Setup.vue?vue&type=template&id=57c3eabb"
import script from "./Setup.vue?vue&type=script&lang=js"
export * from "./Setup.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"static/js/components-wa/messages/Setup.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "57c3eabb"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('57c3eabb', __exports__)) {
    api.reload('57c3eabb', __exports__)
  }
  
  module.hot.accept("./Setup.vue?vue&type=template&id=57c3eabb", () => {
    api.rerender('57c3eabb', render)
  })

}


export default __exports__